import { render, staticRenderFns } from "./VisitorDetail.vue?vue&type=template&id=4463120f&"
import script from "./VisitorDetail.vue?vue&type=script&lang=js&"
export * from "./VisitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./VisitorDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports